export const MEETING_CONTENT_URL = process.env.REACT_APP_MEETING_CONTENT_URL
export const baseURL = process.env.REACT_APP_BASE_URL
export const TRIVIA_DEFINITION_ID = process.env.REACT_APP_ENV === "staging" ? "60251891182a7dfb9b88dc8c" : "6013ffa21f01aa2473c1ab0b"
